import { MessageNotificationData } from "lib/types";
import NotificationsController from "./notifications_controller";

export default class NotificationsEmitterController extends NotificationsController {
  public static values = {
    currentUserEncodedId: { type: String, default: null },
  };

  declare private readonly currentUserEncodedIdValue: any;

  public handleNewMessage(data: MessageNotificationData) {
    const { message } = data;
    if (
      message.sender_user_encoded_id !== this.currentUserEncodedIdValue &&
      message.type === "Message"
    ) {
      this.incrementCounter();
    }

    const event = new CustomEvent("notification", {
      bubbles: true,
      cancelable: false,
      detail: data,
    });
    window.dispatchEvent(event);
  }
}
